module.exports = __webpack_public_path__ + "img/ezhou.dafdee47.png";